"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by Mariam.Melkonyan on 6/27/2016.
 */
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var sis_multilingual_component_1 = require("./sis-multilingual.component");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var sis_multilingual_textarea_settings_1 = require("../control-settings/sis-multilingual-textarea.settings");
var MULTILINGUAL_TEXTAREA_CONTROL_VALUE_ACCESSOR = {
    provide: forms_1.NG_VALUE_ACCESSOR,
    useExisting: core_1.forwardRef(function () { return MultilingualTextarea; }),
    multi: true
};
require("./sis-multilingual-textarea.component.css");
var MultilingualTextarea = /** @class */ (function (_super) {
    __extends(MultilingualTextarea, _super);
    function MultilingualTextarea() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MultilingualTextarea.prototype.closeMenu = function () {
        this.menuTrigger.closeMenu();
    };
    MultilingualTextarea = __decorate([
        core_1.Component({
            
            selector: "sis-multilingual-textarea",
            template: require('./sis-multilingual-textarea.component.html'),
            encapsulation: core_1.ViewEncapsulation.None,
            changeDetection: core_1.ChangeDetectionStrategy.OnPush,
            providers: [MULTILINGUAL_TEXTAREA_CONTROL_VALUE_ACCESSOR]
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            groups: [
                {
                    identity: "Controls",
                    name: "Controls",
                },
            ],
            template: "%{#isreadonly}\n                   <ng-container *ngIf=\"!%{isreadonly}\">\n                        <sis-multilingual-textarea [maxLength]=\"%{maxLength}\" [placeholder]=\"%{placeholder}\" [id]=\"'%{id}'\" [title]=\"title\"\n                                            [languages]=\"languages\" [currentLanguageId]=\"currentLanguageId\" [(ngModel)]=\"%{field}\" [hint]=\"%{hint}\" \n                                            [characterCountSettings]=\"%{characterCountSettings}\" [isRequired]=\"isRequired\" [validations]=\"validations\"></sis-multilingual-textarea>\n                   </ng-container>\n                   <ng-container *ngIf=\"%{isreadonly}\">\n                        <label *ngIf=\"%{field}?.getValue(currentLanguageId)\" [id]=\"'%{id}'\" style=\"white-space: pre-line;\">{{%{field}?.getValue(currentLanguageId)}}</label>\n                        <sis-custom-label *ngIf=\"!%{field}?.getValue(currentLanguageId)\" [key]=\"'reporting.controls.chart-designer.placeholder.noData'\"></sis-custom-label>\n                   </ng-container>\n               %{/isreadonly}\n               %{^isreadonly}\n                   <sis-multilingual-textarea [maxLength]=\"%{maxLength}\" [placeholder]=\"%{placeholder}\" [id]=\"'%{id}'\" [title]=\"title\"\n                                                [languages]=\"languages\" [currentLanguageId]=\"currentLanguageId\" [(ngModel)]=\"%{field}\" [hint]=\"%{hint}\" \n                                                [characterCountSettings]=\"%{characterCountSettings}\" [isRequired]=\"isRequired\" [validations]=\"validations\"></sis-multilingual-textarea>\n               %{/isreadonly}",
            iconInfo: "fa-text-height",
            name: "Multilingual textarea",
            settings: {
                main: sis_multilingual_textarea_settings_1.MultilingualTextareaSettings
            },
            isFieldBound: true
        })
    ], MultilingualTextarea);
    return MultilingualTextarea;
}(sis_multilingual_component_1.MultilingualComponent));
exports.MultilingualTextarea = MultilingualTextarea;
//# sourceMappingURL=sis-multilingual-textarea.component.js.map